export default __webpack_public_path__ + "static/media/jewelery.bf756d25.jpg";